<template>
     <div class="coverinfodetails">
       <v-form ref="form" v-model="valid" @keyup.native.enter="valid && submit()" onSubmit="return false;" lazy-validation>
         <v-layout row>
            <v-flex xs11 offset-xs1>
                <span class="header-title-details">{{$t('Claim.RequestClaim.CLAIM_SUBMISSION_TITLE')}}</span>
                <a v-on:click='closeExtendedMode' class="right">  <span class="icon-close"></span></a>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs11 offset-xs1>
              <div class="invoicedetails">
                <v-label>{{$t('Claim.RequestClaim.INVOICE_NUMBER_FIELD_NAME')}} </v-label>
                <p class="invoicenumber">{{cover.invoice.number}}</p>
              </div>
            </v-flex>
          </v-layout>
          <v-layout row class="submiclaimcontextinfo" style="padding-bottom: 20px !important;">
            <v-flex xs11 offset-xs1>
              <div class="submitbloc">
                  <span class="info-title">{{$t('Claim.RequestClaim.FILE_ATTACHMENT_SUB_TITLE')}}</span>
              </div>
            </v-flex>
          </v-layout>
          <v-layout v-for="(item, index) in claimDocumentsFileTypes" :key="index" row>
            <v-flex xs11 offset-xs1>
              <span >{{item.fileLabel}}</span>
              <UploadDocument :ref="item.fileType" :checkFileName="checkUploadedFileName" :inputId="item.fileType+'Id'" :files="item.files" :title="item.fileTitle" :isRequired="item.isMandatory" :maxFilesCount="item.maxFilesCount"/>
            </v-flex>
          </v-layout>
          <ContactDetailsForm ref="buyerContact" :contact="buyer" :title="buyerContactTitle" />
          <ContactDetailsForm ref="sellerContact" v-if="this.claimExtendedForm" :contact="seller" :title="sellerContactTitle" />
          <v-layout row class="submiclaimcontextinfo">
            <v-flex xs11 offset-xs1>
              <div class="submitbloc">
                  <span class="info-title">{{$t('Claim.RequestClaim.CONTEXT_INFORMATION_SUB_TITLE')}}</span>
              </div>
            </v-flex>
          </v-layout>
          <v-layout row v-if="showCollectedAmount">
            <v-flex xs11 offset-xs1>
              <CurrencyInputField v-model="collectedAmount" :label="$t('Claim.RequestClaim.COLLECTED_AMOUNT_FIELD_NAME')" :placeholder="$t('Claim.RequestClaim.COLLECTED_AMOUNT_PLACEHOLDER')" :disabled="true" :currencies="currencyFlags" :currency="currency" backgroundColor="transparent" />
            </v-flex>
          </v-layout>
          <v-layout row>
           <v-flex xs11 offset-xs1>
            <CurrencyInputField v-model="amountWithoutVAT" :label="$t('Claim.RequestClaim.AMOUNT_WITHOUT_VAT_FIELD_NAME')" :placeholder="$t('Claim.RequestClaim.AMOUNT_WITHOUT_VAT_PLACEHOLDER')" :disabled="true" :currencies="currencyFlags" :currency="currency" backgroundColor="transparent" :maxAmount="cover.invoice.amount.replace(cover.invoice.currency,'').trim()" minAmount="0" />
           </v-flex>
          </v-layout>
          <v-layout row v-if="showDeliveryDate" >
            <v-flex xs11 offset-xs1>
                <div class="calendarleft">
                    <v-menu
                        ref="deliveryDateMenu"
                        v-model="deliveryDateMenu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="deliveryDateFormatted"
                            label="Delivry Date"
                            persistent-hint
                            placeholder="DD/MM/AAAA"
                            prepend-icon="event"
                            v-bind="attrs"
                            clearable
                            readonly
                            @click:clear="resetDeliveryDate()"
                            @blur="date = parseDate(deliveryDateFormatted)"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="deliveryDate"
                          no-title
                          @input="deliveryDateMenu = false"
                        ></v-date-picker>
                      </v-menu>
                </div>
            </v-flex>
          </v-layout>
           <v-layout row v-if="this.claimExtendedForm">
            <v-flex xs11 offset-xs1>
               <v-text-field  :suffix="currency.currency" v-model="fundedAmount" :label="$t('Claim.RequestClaim.FUNDED_AMOUNT_FIELD_NAME')" :placeholder="$t('Claim.RequestClaim.FUNDED_AMOUNT_PLACEHOLDER')" type="number" ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row class="submiclaimcontextinfo">
              <v-flex xs11 offset-xs1>
                <div class="submitclaimfield">
                      <span>{{$t('Claim.RequestClaim.IS_INVOICE_DISPUTED_FIELD_NAME')}}</span>
                      <br/>
                      <div class="choicebtn">
                        <v-btn  color="yesdisputedbtn" @click="activeyesbuttonClaim()">{{$t('Claim.RequestClaim.YES_BTN')}}</v-btn>
                        <v-btn  color="nodisputedbtn" @click="activenobuttonClaim()">{{$t('Claim.RequestClaim.NO_BTN')}}</v-btn>
                      </div>
                </div>
                 <div class="submitclaimfield">
                      <span>{{$t('Claim.RequestClaim.IS_BUYER_UNDER_INSOLVENCY_FIELD_NAME')}}</span>
                      <br/>
                      <div class="choicebtn">
                        <v-btn  color="yesinsolvencybtn" @click="activeyesinsolvencybuttonClaim()">{{$t('Claim.RequestClaim.YES_BTN')}}</v-btn>
                        <v-btn  color="noinsolvencybtn" @click="activenoinsolvencybuttonClaim()">{{$t('Claim.RequestClaim.NO_BTN')}}</v-btn>
                      </div>
                </div>
              </v-flex>
          </v-layout>
          <v-layout row class="submiclaimcontextinfoform">
              <v-flex xs11 offset-xs1>
                <div>
                     <v-text-field v-model="clientRefNumber" :rules="refNumberRules" :label="$t('Claim.RequestClaim.REFERENCE_NUMBER_FIELD_NAME')" :placeholder="$t('Claim.RequestClaim.REFERENCE_NUMBER_PLACEHOLDER')" clearable></v-text-field>
                </div>
                <div>
                     <v-textarea solo v-model="comment" :rules="commentRules" :label="$t('Claim.RequestClaim.COMMENT_FIELD_NAME')"  :placeholder="commentPlaceHolder" clearable></v-textarea>
                </div>
              </v-flex>
          </v-layout>

          </v-form>
     </div>
</template>
<script>
import { mapState } from 'vuex'
import UploadDocument from '@/components/common/UploadDocument'
import ContactDetailsForm from '@/components/cover/claim/ContactDetailsForm'
import CurrencyInputField from '@/components/common/CurrencyInputField'
import coverApi from '@/services/CoverApi'
import dayjs from 'dayjs'

export default {
  data () {
    return {
      valid: true,
      fileuploaded: false,
      error: false,
      errorExternal: false,
      errorfile: false,
      loading: false,
      btndisabled: false,
      emailRules: [
        v => /.+@.+/.test(v) || v.length === 0 || 'E-mail must be valid'
      ],
      requiredRules: [
        v => !!v || 'This field is required'
      ],
      phoneRules: [
        v => /^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,3})|(\(?\d{2,3}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/.test(v) || v.length === 0 || 'Phone number must be valid'
      ],
      refNumberRules: [
        v => v.length <= 20 || v.length === 0 || 'Max 20 characters'
      ],
      commentRules: [
        v => v.length <= 150 || v.length === 0 || 'Max 150 characters'
      ],
      invoicedisputed: null,
      buyerinsolvency: null,
      comment: '',
      clientRefNumber: '',
      fileErrorMessage: '',
      collectedAmount: '',
      amountWithoutVAT: '',
      fundedAmount: '',
      fileMandatroy: 'Providing the invoice image or PDF is mandatory to submit a claim',
      claimExtendedForm: false,
      showCollectedAmount: false,
      showDeliveryDate: false,
      currency: {},
      buyer: {
        firstName: '',
        lastName: '',
        email: '',
        mobilePhone: '',
        officePhone: ''
      },
      seller: {
        firstName: '',
        lastName: '',
        email: '',
        mobilePhone: '',
        officePhone: ''
      },
      buyerContactTitle: this.$t('Claim.RequestClaim.BUYER_CONTACT_SUB_TITLE'),
      sellerContactTitle: this.$t('Claim.RequestClaim.SELLER_CONTACT_SUB_TITLE'),
      maxFilesCount: 10,
      powerOfAttorneyMaxCount: 1,
      powerOfAttorneyDocumentType: 'PowerOfAttorney',
      claimDocumentsFileTypes: [],
      commentPlaceHolder: this.$t('Claim.RequestClaim.COMMENT_PLACEHOLDER'),
      deliveryDate: null,
      deliveryDateFormatted: '',
      deliveryDateMenu: false
    }
  },
  methods: {
    parseDate (date) {
      return this.$formatDateToUniversal(date)
    },
    formatDate (date) {
      return this.$formatDateFromUniversal(date)
    },
    resetDeliveryDate () {
      this.deliveryDate = null
      this.deliveryDateFormatted = ''
    },
    closeExtendedMode () {
      this.$parent.initializeAndCloseExtendedMode()
    },
    activeyesbuttonClaim () {
      if (!$('.yesdisputedbtn').hasClass('primary')) {
        $('.yesdisputedbtn').addClass('primary')
      }
      if ($('.nodisputedbtn').hasClass('primary')) {
        $('.nodisputedbtn').removeClass('primary')
      }
      this.invoicedisputed = true
    },
    activenobuttonClaim () {
      if (!$('.nodisputedbtn').hasClass('primary')) {
        $('.nodisputedbtn').addClass('primary')
      }
      if ($('.yesdisputedbtn').hasClass('primary')) {
        $('.yesdisputedbtn').removeClass('primary')
      }
      this.invoicedisputed = false
    },
    activeyesinsolvencybuttonClaim () {
      if (!$('.yesinsolvencybtn').hasClass('primary')) {
        $('.yesinsolvencybtn').addClass('primary')
      }
      if ($('.noinsolvencybtn').hasClass('primary')) {
        $('.noinsolvencybtn').removeClass('primary')
      }
      this.buyerinsolvency = true
    },
    activenoinsolvencybuttonClaim () {
      if (!$('.noinsolvencybtn').hasClass('primary')) {
        $('.noinsolvencybtn').addClass('primary')
      }
      if ($('.yesinsolvencybtn').hasClass('primary')) {
        $('.yesinsolvencybtn').removeClass('primary')
      }
      this.buyerinsolvency = false
    },
    submitClaimNextStep () {
      this.errorfile = false
      var isClaimFilesValid = true
      this.claimDocumentsFileTypes.forEach(item => {
        isClaimFilesValid &= this.$refs[item.fileType][0].validate()
      })
      if (this.$refs.form.validate() && isClaimFilesValid) {
        let submittedClaim = {
          buyer: this.buyer,
          seller: this.seller,
          invoicedisputed: this.invoicedisputed === true ? 'Yes' : this.invoicedisputed === false ? 'No' : '',
          buyerinsolvency: this.buyerinsolvency === true ? 'Yes' : this.buyerinsolvency === false ? 'No' : '',
          invoicedisputedValue: this.invoicedisputed,
          buyerinsolvencyValue: this.buyerinsolvency,
          comment: this.comment,
          clientRefNumber: this.clientRefNumber,
          collectedAmount: this.collectedAmount,
          amountWithoutVAT: this.amountWithoutVAT,
          fundedAmount: this.fundedAmount,
          deliveryDate: this.deliveryDate ? dayjs(this.deliveryDate).format('YYYY-MM-DD') : null,
          documents: this.claimDocumentsFileTypes.map((item) => {
            return {
              fileType: item.fileType,
              fileTitle: item.fileTitle,
              isMandatory: item.isMandatory,
              files: item.files
            }
          })
        }
        this.$store.dispatch('cover/setSubmittedClaim', submittedClaim)
        this.$parent.activeClaimSummary()
      }
    },
    checkUploadedFileName (fileName) {
      if (this.claimDocumentsFileTypes.length > 0) {
        var files = this.$concatArrays(this.claimDocumentsFileTypes.map((item) => { return item.files }))
        return files.some(c => c.name === fileName)
      }
    },
    async prefillContactDetails () {
      if (this.buyer && this.buyer.id && this.contactIsEmpty(this.buyer)) {
        let contactInfo = await coverApi.getClaimContactInfo(this.buyer.id)
        this.assignContactInfo(this.buyer, contactInfo)
      }

      if (this.seller && this.seller.id && this.contactIsEmpty(this.seller)) {
        let contactInfo = await coverApi.getClaimContactInfo(this.seller.id)
        this.assignContactInfo(this.seller, contactInfo)
      }
    },
    contactIsEmpty (contact) {
      return !contact || (!contact.firstName && !contact.lastName && !contact.email && !contact.mobilePhone && !contact.officePhone)
    },
    assignContactInfo (currentContactInfo, newContactInfo) {
      currentContactInfo.firstName = newContactInfo.firstName
      currentContactInfo.lastName = newContactInfo.lastName
      currentContactInfo.email = newContactInfo.email
      currentContactInfo.mobilePhone = newContactInfo.mobilePhone
      currentContactInfo.officePhone = newContactInfo.officePhone
    }
  },
  watch: {
    deliveryDate (val) {
      this.deliveryDateFormatted = this.formatDate(this.deliveryDate)
    }
  },
  computed: {
    ...mapState('cover', ['cover', 'submittedClaim']),
    ...mapState('userdetails', ['userInfos']),
    ...mapState('countries', ['currencyFlags'])
  },
  async mounted () {
    this.buyer = Object.assign(this.submittedClaim.buyer, { id: this.cover.invoice.buyer.id })
    this.seller = Object.assign(this.submittedClaim.seller, { id: this.cover.invoice.seller.id })
    this.invoicedisputed = this.submittedClaim.invoicedisputedValue
    this.buyerinsolvency = this.submittedClaim.buyerinsolvencyValue
    this.comment = this.submittedClaim.comment
    this.clientRefNumber = this.submittedClaim.clientRefNumber
    this.collectedAmount = this.submittedClaim.collectedAmount
    this.amountWithoutVAT = this.submittedClaim.amountWithoutVAT
    this.fundedAmount = this.submittedClaim.fundedAmount
    this.deliveryDate = this.submittedClaim.deliveryDate
    this.deliveryDateFormatted = this.submittedClaim.deliveryDate ? this.formatDate(this.deliveryDate) : ''
    this.claimExtendedForm = this.userInfos.claimExtendedForm
    this.showCollectedAmount = this.userInfos.claimSettings.showCollectedAmount
    this.showDeliveryDate = this.userInfos.claimSettings.showDeliveryDate
    this.currency = this.currencyFlags.find(c => c.currency.toUpperCase() === this.cover.invoice.currency.toUpperCase())
    this.claimDocumentsFileTypes = this.userInfos.claimSettings.documentFileTypes.map((item) => {
      return {
        fileType: item.fileType,
        fileTitle: this.$t(this.$getFileTypeLabel(item.fileType, this.userInfos.country)),
        fileLabel: item.isMandatory ? this.$t(this.$getFileTypeLabel(item.fileType, this.userInfos.country)).concat(' *') : this.$t(this.$getFileTypeLabel(item.fileType, this.userInfos.country)),
        isMandatory: item.isMandatory,
        maxFilesCount: item.fileType === this.powerOfAttorneyDocumentType ? this.powerOfAttorneyMaxCount : this.maxFilesCount,
        files: this.submittedClaim.documents.length > 0 ? this.submittedClaim.documents.find(doc => doc.fileType === item.fileType).files : []
      }
    })
    if (this.invoicedisputed !== '') {
      if (this.invoicedisputed === true) {
        this.activeyesbuttonClaim()
      } else {
        this.activenobuttonClaim()
      }
    }
    if (this.buyerinsolvency !== '') {
      if (this.buyerinsolvency === true) {
        this.activeyesinsolvencybuttonClaim()
      } else {
        this.activenoinsolvencybuttonClaim()
      }
    }
    if (this.userInfos.country === 'BR') {
      this.commentPlaceHolder = this.$t('Claim.RequestClaim.BR_COMMENT_PLACEHOLDER')
    }
    await this.prefillContactDetails()
  },
  components: {
    UploadDocument,
    ContactDetailsForm,
    CurrencyInputField
  }
}
</script>
<style>

.submiclaimcontextinfoform {
  padding-top: 15px
}
.submiclaimcontextinfo {
  padding-bottom: 25px;
}

.action {
  width: 30%;
}
.imgfile, .imgactionfile {
  width: 24px;
  height: 24px;
  display: inline-block;
}

.imgfile{
  padding-top: 2px;
  padding-left: 2px
}

.imgactionfile{
  cursor: pointer;
  margin-left: 12px;
}

div.file-listing{
    width: 200px;
  }

.submitbloc {
  padding-top: 18px
}

.submitform{
  padding-top: 20px
}

.submiclaimcontextinfo {
  padding-top: 1px
}

.choicebtn {
  padding-top: 11px;
  display: inline-block;
  margin-left: -7px;
}

.submitclaimfield{
  padding-top: 10px;
}
.submitclaimfilefield{
   padding-top: 20px;
}

.v-btn-toggle--selected {
  box-shadow: none;
  -webkit-box-shadow : none;
  background: rgba(249, 250, 252, 1.0) !important
}

.v-text-field {
  position: relative;
  margin-top: 6px;
}
.v-text-field .v-input__control,
.v-text-field .v-input__slot,
.v-text-field .v-text-field__slot,
.v-text-field .v-menu,
.v-text-field .v-menu__activator {
  position: unset;
}
.v-text-field .v-input__append-outer,
.v-text-field .v-input__prepend-outer {
  margin-top: 8px;
  margin-bottom: 8px;
}
.v-text-field .v-input__append-inner,
.v-text-field .v-input__prepend-inner {
  align-self: center;
  margin: 0;
  padding: 0;
}
.v-text-field .v-input__prepend-inner {
  margin-right: 8px;
}
.v-text-field .v-input__append-inner {
  margin-left: 8px;
}
.v-textarea .v-input__slot {
  height: 100% !important;
}
.v-text-field .v-input__slot {
  height: 40px;
  padding: 4px 8px;
  border: 1px solid #bccaca;
  border-radius: 5px;
  transition: border-color 0.2s ease-in-out;
}
.v-text-field .v-input__slot:before {
  display: none;
}
.v-text-field .v-input__slot:after {
  display: none;
}
.v-text-field .v-input__slot input {
  padding: 0;
}
.v-text-field .v-input__slot label {
  transform: translateY(-32px);
  font-size: 18px;
  transition: color 0.2s ease-in-out;
}
.v-text-field.v-input--is-disabled .v-input__slot {
  background-color: #eeeeee;
}
.v-text-field.v-input--has-state.error--text:not(.v-input--is-focused) .v-input__slot {
  border-color: #ff5252;
}
.v-text-field.v-input--is-focused .v-input__slot {
  border-color: var(--primary-color) !important;
}
.v-text-field.v-input--is-focused:not(.v-input--has-state):not(.error--text) .v-label {
  color: var(--primary-color) !important;
}
.v-input .v-label{
      margin-top: -4px;
      margin-left: -8px

}
.v-text-field__slot  label {
    font-size: 11.0px !important;
    color: rgba(159, 166, 174, 1.0) !important
}

</style>
